module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("UF")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ufSelecionada),
      expression: "ufSelecionada"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ufSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf.id
      }
    }, [_vm._v(_vm._s(uf.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Ano")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anoSelecionado),
      expression: "anoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.anoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.anos), function(i) {
    return _c('option', [_vm._v(_vm._s(i.ano))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Mês")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesSelecionado),
      expression: "mesSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading || _vm.anoSelecionado == null
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mesSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      domProps: {
        "value": mes
      }
    }, [_vm._v(_vm._s(mes.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contrato")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contratoSelecionado),
      expression: "contratoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading,
      "align": "center"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contratoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.tipo_imovel_servicos), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.limparFiltro()
      }
    }
  }, [_vm._v(" Limpar Filtro\n        ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(1), _vm._v(" "), _c('HalfCircleSpinner', {
    staticStyle: {
      "margin": "0 auto",
      "float": "none"
    },
    attrs: {
      "animation-duration": 2000,
      "size": 60,
      "color": '#3c8dbc'
    }
  })], 1) : (_vm.fechamentos != '') ? _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.records), function(fechamento, index) {
    return (index + 1 >= _vm.startIndex && index + 1 <= _vm.endIndex && !_vm.loading) ? _c('tr', {
      key: fechamento.id,
      attrs: {
        "key": fechamento.id
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "title": "Detalhes fechamento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.detalhesFechamentoExtra(fechamento.id)
        }
      }
    }, [_vm._v(_vm._s(fechamento.id))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.uf))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.tipo_imovel_servico))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.ano_de_referencia))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(fechamento.servicos && fechamento.servicos.length > 0) ? _c('span', _vm._l((fechamento.servicos), function(servico) {
      return _c('span', {
        key: servico.id,
        staticClass: "badge-servico"
      }, [_vm._v(_vm._s(servico.descricao))])
    }), 0) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "title": "Excluir",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.excluirFechamentoExtra(fechamento.id)
        }
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": "trash-fill",
        "font-scale": "1.2",
        "aria-hidden": "true"
      }
    })], 1)])]) : _vm._e()
  })], 2)])]) : _c('div', [(this.filtro == null) ? _c('h4', {
    staticClass: "form-inline"
  }, [_vm._v(" Você não possui fechamento preenchido. ")]) : _c('h4', {
    staticClass: "form-inline"
  }, [_vm._v(" Você não possui fechamento extracontratual filtrado. ")])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('pagination', {
    attrs: {
      "records": _vm.recordsLength,
      "per-page": _vm.perPage
    },
    on: {
      "paginate": _vm.getPage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-header"
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Fechamento Extracontratual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Carregando Dados. "), _c('p', [_vm._v(" Aguarde um momento...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Mês")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Serviços")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ação")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41365ba2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aplicacaoFechamentoExtra/ExibirFechamentoExtra.vue
// module id = 981
// module chunks = 1